import { render, staticRenderFns } from "./NewOrgan.vue?vue&type=template&id=600c22b7&"
import script from "./NewOrgan.vue?vue&type=script&lang=ts&"
export * from "./NewOrgan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/views/_locales/organs.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Forgans%2FNewOrgan.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/components/_locales/Organs.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Forgans%2FNewOrgan.vue"
if (typeof block1 === 'function') block1(component)

export default component.exports